module.exports = __webpack_public_path__ + "static/media/pic21@3x.b9b73ece.png";